"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineClassifierEntity = void 0;
const saveClassifierPublicData_1 = require("../utils/saveClassifierPublicData");
function defineClassifierEntity(classifier, dataSchema) {
    const onScheduleChangedAsync = (context, params) => {
        var _a, _b;
        const actionParams = params.actionParams;
        return (!(actionParams === null || actionParams === void 0 ? void 0 : actionParams.internal) && !!classifier.publicData) || !!((_b = (_a = classifier.entity).onScheduleChangedAsync) === null || _b === void 0 ? void 0 : _b.call(_a, context, params));
    };
    const onChangedAsync = (context, params) => {
        var _a, _b;
        if (classifier.publicData === true) {
            (0, saveClassifierPublicData_1.saveClassifierPublicData)(context, { entityName: params.entity }, true);
        }
        else if (Array.isArray(classifier.publicData)) {
            for (const savePublicDataParams of classifier.publicData) {
                (0, saveClassifierPublicData_1.saveClassifierPublicData)(context, Object.assign(Object.assign({}, savePublicDataParams), { entityName: params.entity }), true);
            }
        }
        else if (typeof classifier.publicData === 'function') {
            classifier.publicData(context.storage(params.entity), context.publicData, true);
        }
        (_b = (_a = classifier.entity).onChangedAsync) === null || _b === void 0 ? void 0 : _b.call(_a, context, params);
    };
    const classifierDef = Object.assign(Object.assign({}, classifier), { entity: Object.assign(Object.assign({ audit: {
                columnForAuditIdReplacement: 'name',
            } }, classifier.entity), { onScheduleChangedAsync,
            onChangedAsync }) });
    if (dataSchema) {
        const validatedDef = Object.assign(Object.assign({}, classifierDef), { entity: Object.assign(Object.assign({}, classifierDef.entity), { onAuthPost: (appState, userState, params, context) => {
                    var _a, _b;
                    if (params.action === 'create' || params.action === 'update') {
                        const validationResult = dataSchema.safeParse(params.data, {});
                        if (!validationResult.success) {
                            throw new Error(validationResult.error.issues.map((issue) => issue.message).join('; '));
                        }
                    }
                    return (_b = (_a = classifierDef.entity).onAuthPost) === null || _b === void 0 ? void 0 : _b.call(_a, appState, userState, params, context);
                } }) });
        if (classifierDef.entity.onAnonymousAuthPostCreate) {
            validatedDef.entity.onAnonymousAuthPostCreate = (appState, params, validationContext) => {
                var _a, _b;
                const validationResult = dataSchema.safeParse(params.data);
                if (!validationResult.success) {
                    throw new Error(validationResult.error.issues.map((issue) => issue.message).join('; '));
                }
                return (_b = (_a = classifierDef.entity).onAnonymousAuthPostCreate) === null || _b === void 0 ? void 0 : _b.call(_a, appState, params, validationContext);
            };
        }
        return validatedDef;
    }
    return classifierDef;
}
exports.defineClassifierEntity = defineClassifierEntity;
